import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useRecoilState } from 'recoil'

import Loading from '@/shared/components/common/Loading'
import { TYPE_HOME_TERMS } from '@/shared/constant/cmdtype'
import { useGetTermsQueryData } from '@/shared/hooks/reactquery'
import { HomeTermsState } from '@/shared/store'
import { HomeTermsDetail } from '@/shared/types/type'
import { captureHomeTermsError } from '@/shared/utils/sentry/validation'
import {
  TelecomTab,
  TelecomTabContent,
  TermsContent,
  TermsOptionItem,
  TermsOptionWrap,
  TermsWrap,
} from '@/styles/views/Terms'

const TermsPage = () => {
  const { isLoading, data: TermsData, isSuccess } = useGetTermsQueryData(TYPE_HOME_TERMS)
  const [termsList, setTermsList] = useRecoilState(HomeTermsState)
  const telecomParams = Number(useParams().telecom || '0')
  const termsParams = Number(useParams().terms || '1')

  const TelecomOption = [
    { tel: 'SKT', padding: '36.5px', idx: 0 },
    { tel: 'KT', padding: '43.5px', idx: 1 },
    { tel: 'LG U+', padding: '43px', idx: 2 },
  ]

  const linkPath = (option: number) => {
    return `/terms/${telecomParams}/${option}`
  }

  useEffect(() => {
    if (isSuccess && TermsData?.Body) {
      const data = TermsData.Body
      setTermsList([data.SKTTerms, data.KTTerms, data.LGUPTerms])
      captureHomeTermsError(data)
    }
  }, [isSuccess, TermsData, setTermsList])

  return (
    <>
      {TermsData && (
        <TermsWrap>
          {isLoading && <Loading />}
          <TelecomTab>
            {TelecomOption.map((option: { tel: string; padding: string; idx: number }) => (
              <TelecomTabContent
                to={`/terms/${option.idx}/1`}
                key={option.tel}
                padding={option.padding}
                active={`${telecomParams === option.idx}`}
              >
                {option?.tel}
              </TelecomTabContent>
            ))}
          </TelecomTab>
          <TermsOptionWrap>
            {termsList[telecomParams]?.Terms.map((terms: HomeTermsDetail, index: number) => (
              <TermsOptionItem
                active={`${termsParams === index + 1}`}
                to={linkPath(index + 1)}
                key={index}
              >
                {terms.Title}
              </TermsOptionItem>
            ))}
          </TermsOptionWrap>
          <TermsContent>
            <pre
              dangerouslySetInnerHTML={{
                __html: termsList[telecomParams]?.Terms[termsParams - 1]?.Contents || '',
              }}
            />
          </TermsContent>
        </TermsWrap>
      )}
    </>
  )
}
export default TermsPage
